import 'src/global.css';

// ----------------------------------------------------------------------
import { Router } from 'src/routes/sections';

import { useScrollToTop } from 'src/hooks/use-scroll-to-top';

import { CONFIG } from 'src/config-global';
import { LocalizationProvider } from 'src/locales';
import { I18nProvider } from 'src/locales/i18n-provider';
import { ThemeProvider } from 'src/theme/theme-provider';
import MaintenancePage from 'src/pages/error/maintenance';

import { Snackbar } from 'src/components/snackbar';
import { LoadingOverlay } from 'src/components/backdrop';
import { ProgressBar } from 'src/components/progress-bar';
import { MotionLazy } from 'src/components/animate/motion-lazy';
import { CommandPalette } from 'src/components/command-palette';
import { AppErrorBoundary } from 'src/components/error-boundary/app-error-boundary';
import { SettingsDrawer, defaultSettings, SettingsProvider } from 'src/components/settings';

import { AuthProvider } from 'src/auth/context/jwt';

// ----------------------------------------------------------------------

export default function App() {
  useScrollToTop();

  return (
    <I18nProvider>
      <LocalizationProvider>
        <AuthProvider>
          <SettingsProvider settings={defaultSettings}>
            <ThemeProvider>
              <AppErrorBoundary>
                <MotionLazy>
                  {
                    CONFIG.underMaintenance ? <MaintenancePage /> : (
                      <>
                        <LoadingOverlay />
                        <Snackbar />
                        <ProgressBar />
                        <SettingsDrawer />
                        <CommandPalette />
                        <Router />
                      </>
                    )
                  }
                </MotionLazy>
              </AppErrorBoundary>
            </ThemeProvider>
          </SettingsProvider>
        </AuthProvider>
      </LocalizationProvider>
    </I18nProvider>
  );
}
